import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Societe, statuts } from '../../../models/societe';

@Component({
  selector: 'formsociete',
  templateUrl: './formsociete.component.html',
  styleUrls: ['./formsociete.component.scss']
})
export class FormsocieteComponent implements OnInit {

  statuts = statuts;
  @Input('group') 
  public societeForm: FormGroup;
  @Input('societe') societe;
  adresseForm: FormGroup;

  constructor(private _fb: FormBuilder) {
    
  }

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/societe/formsociete/formsociete.component.ts